<template>
  <div style="padding-top:100px;">
    <!-- start hero -->
    <div id="hero" class="jarallax" data-speed="0.7" data-img-position="50% 80%" style="background-image: url(img/FuerzaDeVentas.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-7">
            <h1 class="__title"><span>Nuestros</span> orígenes</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- end hero -->

    <main role="main">
      <link rel="stylesheet" href="css/style.min.css" type="text/css">

      <!-- start section -->
          <section class="section">
            <div class="container">
              <h2 class="__title">Somos <span>Grupo ABS</span></h2>
              <p class="text-content">Nacemos en 1994; obtuvimos una distribución de productos biológicos de una compañia estadounidense y nos iniciamos en el MIP y E (Manejo Integrado de Plagas y Enfermedades), como agricultores era un gran reto tener productos de alta productividad.</p>
              <p class="text-content">El manejo integrado de la mosca en corrales de engorda fue nuestro primer proyecto exitoso, donde se demostró la viabilidad y eficacia de nuestras técnicas de control.</p>
              <p class="text-content">Tuvimos la oportunidad de abrir nuestra línea comercial de agroquímicos para ofrecer al sector agrícola y pecuario, un portafolio completo de sistemas y productos para nutrición, control de plagas y enfermedades, desarrollando además nuestra propia línea de productos PREMIUM.</p>
            </div>
          </section>
          <!-- end section -->

          <!-- <section class="section" style="">
              <div class="special-offer special-offer--style-1">
                <h2 class="text text-center lazy"  data-src="img/special_offer_text_bg.jpg">Grupo ABS</h2>
                <h1 class="text-center">Grupo ABS</h1>
              </div>
          </section> -->

          <!-- start section -->
          <section class="section our-products">
            <div class="container">
              <div class="special-offer special-offer--style-1">
                <!-- <h2 class="text text-center lazy"  data-src="img/special_offer_text_bg.jpg">Grupo ABS</h2> -->
                <h1 class="text-center">Grupo ABS</h1>
              </div>
              <div class="row our-products-wrapper">
                <div class="col-12 col-md">
                  <div class="our-product-item">
                    <h2 class="__title">Agrobiosol<br><span>de México S.A. de C.V.</span></h2>
                    <p class="text-content">División producción, comercialización y distribución de agrobiológicos.</p>
                  </div>
                </div>
                <div class="col-12 col-md our-products-item">
                  <div class="our-product-item">
                    <h2 class="__title">ABS<br><span>promotora de México</span></h2>
                    <p class="text-content">Divisón comercialización y distribución de agrobioquímicos.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- end section -->

          <!-- start section -->
          <section class="section section--gutter section--base-bg section--custom-02 timeline-section">
            <div class="container">
              <div class="section-heading">
                <h2 class="__title" style="color:#fff">Nuestra historia<br><span>Pensando con el cliente y para el cliente</span></h2>
              </div>

              <!-- start timeline -->
              <div class="timeline">
                <div class="__inner">
                  <div class="row">
                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>1994</h3>
                            <p  style="color:#333">
                              Año en que nacemos, obteniendo una distribucion de productos biológicos de una compañia estadounidense.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>1997</h3>
                            <p style="color:#333">
                              Se funda AGROBIOSOL DE MÉXICO S.A. DE C.V.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>2004</h3>
                            <p style="color:#333">
                              ABS PROMOTORA DE MÉXICO S.A. DE C.V. es fundada.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>2009</h3>
                            <p style="color:#333">
                              Tenemos nuestra primer sucursal, en la ciudad de Los Mochis.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>2015</h3>
                            <p style="color:#333">
                              Se obtiene registo OMRI por primera vez en productos ABS LINEA PREMIUM.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                    <!-- start item -->
                    <div class="col-12 col-md">
                      <div class="__item">
                        <i class="__ico"></i>

                        <div class="row">
                          <div class="col-lg-11 col-xl-9">
                            <h3>2019</h3>
                            <p style="color:#333">
                              En la actualidad contamos con 11 sucursales en 5 estados del país ¡Y vamos por más!
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end item -->

                  </div>
                </div>
              </div>
              <!-- end timeline -->
            </div>
          </section>
          <!-- end section -->

          <section class="section">
            <div class="container">
              <div class="section-heading section-heading--center">
                <h2 class="__title">Proveedores estratégicos</h2>
                <p>Grandes alianzas con los mejores</p>
              </div>

              <div>
                <carousel :autoplay="true" :items="6" :dots="false" :loop="false" :nav="false" style="background-color:#fff;">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/1.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/2.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/3.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/4.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/5.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/6.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/7.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/8.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/9.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/10.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/11.jpg">
                  <img style="width: 100%; padding: 12px;" src="img/carousel_index/12.jpg">
                </carousel>
              </div>

            </div>
          </section>

          <Contact />
    </main>
  </div>
</template>

<script>
import Map from '@/components/Map.vue'
import Contact from '@/components/Contact.vue'
import carousel from 'vue-owl-carousel'

export default {
  components: {
    Map,
    Contact,
    carousel
  }
};
</script>

<style>
/* Slideshow container */
            .slideshow-container {
              max-width: 1000px;
              position: relative;
              margin: auto;
            }

            /* Caption text */
            .text {
              color: #333;
              font-size: 15px;
              padding: 8px 12px;
              position: absolute;
              bottom: 8px;
              width: 100%;
              text-align: center;
            }

            /* Number text (1/3 etc) */
            .numbertext {
              color: #333;
              font-size: 12px;
              padding: 8px 12px;
              position: absolute;
              top: 0;
            }

            .active {
              /*background-color: #717171;*/
            }

            /* Fading animation */
            .fade {
              -webkit-animation-name: fade;
              -webkit-animation-duration: 1.5s;
              animation-name: fade;
              animation-duration: 1.5s;
            }

            @-webkit-keyframes fade {
              from {opacity: .4} 
              to {opacity: 1}
            }

            @keyframes fade {
              from {opacity: .4} 
              to {opacity: 1}
            }

            /* On smaller screens, decrease text size */
            @media only screen and (max-width: 300px) {
              .text {font-size: 11px}
            }
</style>
